<template>
  <v-dialog v-model="dialog" width="800px" scrollable>
    <v-card>
      <v-card-title class="d-flex">
        Quick / Express Recharge
        <v-spacer></v-spacer>
        <close-icon-button @click="dialog = false"></close-icon-button>
      </v-card-title>
      <v-card-text>
        <v-card outlined v-for="(item, i) in list" :key="i" class="mb-2">
          <v-card-text class="pa-2">
            <v-row>
              <v-col
                cols="3"
                class="d-flex flex-column align-center justify-space-between"
              >
                <image-view
                  width="30px"
                  height="30px"
                  :src="getURL(item)"
                ></image-view>
                <div class="body-2 font-weight-bold mt-1">
                  {{ item.service }}
                </div>
              </v-col>
              <v-col class="d-flex flex-column justify-space-between">
                <div class="title black--text flex-1 d-flex align-center mt-1">
                  ₹{{ item.amount }}
                </div>
                <div class="body-2">Amount</div>
              </v-col>
              <v-col class="d-flex flex-column justify-space-between">
                <div class="title black--text flex-1 d-flex align-center mt-1">
                  {{
                    item.perc == "True" ? `${item.value}%` : `₹${item.value}`
                  }}
                </div>
                <div class="body-2">Discount</div>
              </v-col>
              <v-col class="d-flex flex-column justify-space-between">
                <div class="title black--text flex-1 d-flex align-center mt-1">
                  ₹{{ formatNumber(item.effective_amount) }}
                </div>
                <div class="body-2">Saving</div>
              </v-col>
              <v-col class="d-flex flex-column justify-space-between">
                <div class="title black--text flex-1 d-flex align-center mt-1">
                  ₹{{ formatNumber(item.net_amount) }}
                </div>
                <div class="body-2">Net Amount</div>
              </v-col>
            </v-row>
            <div class="d-flex align-center mt-2">
              <div class="flex-1">
                {{ item.remark == "*" ? "" : item.remark }}
              </div>
              <do-recharge v-if="isDo(item)" :item="item"></do-recharge>
              <v-btn
                depressed
                tile
                v-else
                class="primary"
                small
                @click="open(item)"
              >
                Do Recharge
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getURL, RECHARGE_TYPE } from "../../assets/js/common";
import CloseIconButton from "../buttons/CloseIconButton.vue";
import ImageView from "../ImageView.vue";
import DoRecharge from "./DoRecharge.vue";
export default {
  components: { CloseIconButton, ImageView, DoRecharge },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    list() {
      let list = this.$store.getters.quick_recharge;
      return list instanceof Array ? list : [];
    },
  },
  methods: {
    isDo({ service_type }) {
      if (service_type) service_type = service_type.toLowerCase();
      let list = ["rr", "pp", "dth", "stv"];
      return list.indexOf(service_type) !== -1;
    },
    getURL({ circle_img_path }) {
      return getURL(circle_img_path);
    },
    formatNumber(val) {
      if (isNaN(Number(val))) return val;
      return Number(val).toFixed(2);
    },
    async init() {
      const vm = this;
      try {
        let data = await vm.$store.dispatch("fetchQuickRecharge");
        if (data.length > 0) vm.dialog = true;
      } catch (error) {
        console.log(error.message);
      }
    },
    open(item) {
      let way = RECHARGE_TYPE[item.service_type];
      this.$router.push({
        name: "recharge",
        query: {
          way,
          service: item.service,
          amount: item.amount,
        },
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>